var Tooltip = {
	
	init: function() {
		if (Tooltip.initialized == undefined) {
			Tooltip.node = $("<div style='position: absolute;left:0px;top:0px;padding: 4px; background-color: #ffffff;border-radius: 4px; color: #000000;pointer-events: none; opacity: 0;font-size:12px;'></div>");
			Tooltip.initialized = true;
			$("body").append(Tooltip.node);

			setInterval(Tooltip.process, 20);
		}
	},

	show: function(txt) {
		Tooltip.init();
		Tooltip.node.html(txt);

		Tooltip.node.css("opacity", 1);
		if (Tooltip.hiding != undefined) clearTimeout(Tooltip.hiding);

		Tooltip.hiding = setTimeout(function() {
			Tooltip.node.css("opacity", 0);
			Tooltip.hiding = undefined;
		}, 20);
	},

	process: function() {
		Tooltip.node.css("left", player._mouseHoverX);
		Tooltip.node.css("top", player._mouseHoverY);
	}
}